import { DrawerLabel } from './DrawerLabel';

export const FlightChecklistDrawerLabel: React.FC = () => {
    return <DrawerLabel text="Advisories" />;
};
